import { PropsWithChildren, useEffect } from 'react';
import { useGPTBanner } from '../store';
import dayjs from 'dayjs';

export const GPTBannersContainer = ({ children }: PropsWithChildren) => {
  const bannerStates = useGPTBanner();

  useEffect(() => {
    if (bannerStates.closeTime !== dayjs().format('DD.MM')) {
      bannerStates.showAllBanners();
    }
  }, []);

  return children;
};
